import { Link } from 'react-router-dom';
import Header from './layout/Header';
import Footer from './layout/Footer';
import Slider from "react-slick";
import Service from './../service';
import toast, { } from 'react-hot-toast';
import React, { useState, useEffect } from "react";
import moment from 'moment-timezone';
import MetaHelmet from './metaHelmet'; //Include metaHelmet

var slider_settings = {
   pauseOnHover: true,
   autoplay: true,
   autoplayspeed: 2000,
   speed: 1000,
   centerMode: true,
   centerPadding: '0%',
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   dots: false,
   draggable: true,
   responsive: [{
      breakpoint: 991,
      settings: {
         slidesToShow: 1,
      }
   },
   {
      breakpoint: 580,
      settings: {
         slidesToShow: 1,
      }
   }]

};

var slider_settings_2 = {
   speed: 1500,
   slidesToShow: 4,
   slidesToScroll: 2,
   autoplay: true,
   autoplaySpeed: 4000,
   dots: false,
   arrows: true,
   centerMode: false,
   responsive: [{
      breakpoint: 1024,
      settings: {
         slidesToShow: 3,
         slidesToScroll: 1,
         // centerMode: true,

      }

   }, {
      breakpoint: 800,
      settings: {
         slidesToShow: 3,
         slidesToScroll: 2,
         dots: true,
         infinite: true,
         centerMode: false,

      }
   }, {
      breakpoint: 580,
      settings: {
         slidesToShow: 2,
         slidesToScroll: 1,
         dots: true,
         infinite: true,
         autoplay: true,
         autoplaySpeed: 2000,
         centerMode: false,
      }
   }]
};

var slider_settings_3 = {
   pauseOnHover: true,
   autoplay: true,
   autoplayspeed: 2000,
   speed: 1000,
   centerMode: true,
   centerPadding: '0%',
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   dots: false,
   draggable: true,
   responsive: [{
      breakpoint: 991,
      settings: {
         slidesToShow: 1,
      }
   },
   {
      breakpoint: 580,
      settings: {
         slidesToShow: 1,
      }
   }]

};


var slider_settings_4 = {
   speed: 1500,
   slidesToShow: 4,
   slidesToScroll: 2,
   autoplay: true,
   autoplaySpeed: 4000,
   dots: false,
   arrows: true,
   centerMode: false,
   responsive: [{
      breakpoint: 1024,
      settings: {
         slidesToShow: 3,
         slidesToScroll: 1,
         // centerMode: true,

      }

   }, {
      breakpoint: 800,
      settings: {
         slidesToShow: 3,
         slidesToScroll: 2,
         dots: true,
         infinite: true,

      }
   }, {
      breakpoint: 580,
      settings: {
         slidesToShow: 2,
         slidesToScroll: 1,
         dots: true,
         infinite: true,
         autoplay: true,
         autoplaySpeed: 2000,
      }
   }]
};

const api = new Service();

function Pages(props) {

   const [PageContent, setdata] = useState({});

   const [config, setconfig] = useState(props.config);


   useEffect(() => {
      GetPageDetails();
   }, [])

   const GetPageDetails = () => {
      api.getApi('get-news-pages', { page_name: 'news', timezone: moment.tz.guess() }).then(response => {
         setdata(response);
         console.log(response);
      }).catch(error => {
         toast.error(error.message);
      });
   }




   const [metaDetail, setMetaDetail] = useState({});


   const GetMetaDetail = () => {
      api.getApi('getMetaByPageName', { page_name: '/move-it-news' }).then(response => {
         console.log(response, 'responseName')
         if (response && response.record) {
            console.log(response, 'getting response');
            setMetaDetail(response.record)

         }

      }).catch(error => {
         toast.error(error.message);
      });
   }

   useEffect(() => {
      GetMetaDetail();
   }, []);

   useEffect(() => {
      document.title = metaDetail.meta_title;
      window.gtag('config', config.G_TAG, {
         page_title: metaDetail.meta_title,
         page_path: window.location.pathname,
      });
   }, [metaDetail]);

   return (
      <>
         {metaDetail ?
            <MetaHelmet title={metaDetail.meta_title} description={metaDetail.meta_description} />
            : ''}
         {/* <MetaHelmet title="Move It - News" description="Move It is becoming one of the fastest-growing technology platforms. Connect with our news section to get the latest information we post every week." /> */}
         <Header></Header>
         {PageContent && PageContent.blog_img ?
            <section className="hero clean" style={{ backgroundImage: "url(" + PageContent.blog_img + ")" }} >
               <article>
                  <div className="grid">
                     <div className="unit-2-3 unit-1-1-md">
                        <h1 className="h2 blog_sub_title f-46">{PageContent.blog_title}</h1>

                     </div>
                  </div>
               </article>
            </section>
            : ''}


         {PageContent && PageContent.content_title && PageContent.content_title.length > 0 && (
            <section className="pb-0 pt-5">
               <div className="container">
                  <div className="row">
                     <div className="col-md-12">
                        <div className="grid grid-center margin-bottom-md text-left">
                           <div className="unit-2-3 unit-1-1-md blog-t">
                              <h2 className="flourish text-left">
                                 <span className="flourish-square">
                                    <svg
                                       xmlns="http://www.w3.org/2000/svg"
                                       viewBox="0 0 150 150"
                                       width="150"
                                       height="150"
                                       preserveAspectRatio="xMidYMid meet"
                                       style={{ width: '100%', height: '100%', transform: 'translate3d(0px, 0px, 0px)' }}
                                    >
                                       <defs>
                                          <clipPath id="__lottie_element_147">
                                             <rect width="150" height="150" x="0" y="0"></rect>
                                          </clipPath>
                                       </defs>
                                       <g clipPath="url(#__lottie_element_147)">
                                          <g style={{ display: 'block' }} transform="matrix(1,0,0,1,459,133.5)" opacity="1">
                                             <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                                <path
                                                   strokeLinecap="butt"
                                                   strokeLinejoin="miter"
                                                   fillOpacity="0"
                                                   strokeMiterlimit="4"
                                                   stroke="rgb(232,154,167)"
                                                   strokeOpacity="1"
                                                   strokeWidth="10"
                                                   d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"
                                                ></path>
                                             </g>
                                          </g>
                                       </g>
                                    </svg>
                                 </span>
                                 {PageContent.content_title[0].title}
                              </h2>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="row">
                     <div className="container full-width latestBlogSliderFour">
                        <Slider {...slider_settings_2} className="carousel">
                           {PageContent.content_title[0].page_content && PageContent.content_title[0].page_content.length > 3 &&
                              PageContent.content_title[0].page_content.slice(3).map((option_1, index_1) => (
                                 <div key={index_1}>
                                    <Link to={'/' + option_1.page_title_alias} className="topBlogSmallList" tabIndex="0">
                                       <div className="leftImgB">
                                          <img
                                             src={option_1.content_photo}
                                             className="attachment-medium size-medium wp-post-image"
                                             alt={option_1.content_title}
                                             loading="lazy"
                                          />
                                       </div>
                                       <div className="contentTopBlog">
                                          <p>{option_1.created_datetime || 'Unknown Date'}</p>
                                          <h6>{option_1.content_title}</h6>
                                       </div>
                                    </Link>
                                 </div>
                              ))}
                        </Slider>
                     </div>
                  </div>
               </div>
            </section>
         )}

         {/* <section className="pb-0 pt-5">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">
                     <div className="grid grid-center margin-bottom-md text-left">
                        <div className="unit-2-3 unit-1-1-md blog-t">
                           <h2 className="flourish text-left">
                              <span className="flourish-square">
                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="150" height="150" preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "100%", transform: "translate3d(0px, 0px, 0px)" }}><defs><clipPath id="__lottie_element_147"><rect width="150" height="150" x="0" y="0"></rect></clipPath></defs><g clipPath="url(#__lottie_element_147)"><g style={{ display: "block" }} transform="matrix(1,0,0,1,459,133.5)" opacity="1"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke="rgb(232,154,167)" strokeOpacity="1" strokeWidth="10" d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"></path></g></g></g></svg>
                              </span>Moving, Pickup/Delivery, and Junk Removal </h2>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="container full-width latestBlogSliderFour">
                     <Slider {...slider_settings_2} className="carousel">
                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1746189701.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>
                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1746439249.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>
                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1745834996.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>
                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1739952034.webp" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>
                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1744802234.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>
                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1736148152.jpg" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>

                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1739952034.webp" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>
                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1744802234.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>
                        <div>
                           <a href="" className="topBlogSmallList">
                              <div className="leftImgB">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1736148152.jpg" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </div>
                              <div className="contentTopBlog">
                                 <p>May 28, 2025</p>
                                 <h6>Why You Should Hire Professional Packers for a Faster Move</h6>
                              </div>
                           </a>
                        </div>

                     </Slider>
                  </div>

               </div>
            </div>
         </section> */}

         {PageContent && PageContent.content_title && PageContent.content_title.length > 0 && (
            <section className="pt-1 blogSliderBig pb-5">
               <article>
                  <div className="grid grid-lg grid-center">
                     <div className="row">
                        <div className="container full-width">
                           <Slider {...slider_settings} className="bf-testimonial-slick">
                              {PageContent.content_title[0].page_content && PageContent.content_title[0].page_content.length > 0 &&
                                 PageContent.content_title[0].page_content.slice(0, 3).map((option_1, index_1) => (
                                    <div className="bf-testimonial-slick-single" key={index_1}>
                                       <Link to={'/' + option_1.page_title_alias} style={{ color: "white" }}>
                                          <div
                                             className="imgBigSlider"
                                             style={{ backgroundImage: `url(${option_1.content_photo})` }}
                                          >
                                             <div className="contentBigSlider">
                                                <p>{option_1.created_datetime || 'Unknown Date'}</p>
                                                <h6>{option_1.content_title}</h6>
                                             </div>
                                          </div>
                                       </Link>
                                    </div>
                                 ))}
                           </Slider>
                        </div>
                     </div>
                  </div>
               </article >
            </section >
         )
         }
         {/* <section className="pt-1 blogSliderBig pb-5">
            <article>
               <div className="grid grid-lg grid-center padding-top-sm">

                  <div className=" row">
                     <div className="container full-width">
                        <Slider {...slider_settings} className="bf-testimonial-slick">
                           <div className="bf-testimonial-slick-single">
                              <div className="imgBigSlider" style={{ backgroundImage: `url("web/img/avif-img/04.avif")` }}>
                                 <div className="contentBigSlider">
                                    <p>May 27, 2025</p>
                                    <h6>The Rise of Eco-Friendly Moving Companies What to Look For</h6>
                                 </div>
                              </div>
                           </div>
                           <div className="bf-testimonial-slick-single">
                              <div className="imgBigSlider" style={{ backgroundImage: `url("web/img/avif-img/05.avif")` }}>
                                 <div className="contentBigSlider">
                                    <p>May 27, 2025</p>
                                    <h6>The Rise of Eco-Friendly Moving Companies What to Look For</h6>
                                 </div>
                              </div>
                           </div>

                        </Slider>
                     </div>

                  </div>

               </div>
            </article>
         </section> */}

         {
            PageContent && PageContent.content_title && PageContent.content_title.length > 1 && (
               <section className="demandMove">
                  <div className="container">
                     <div className="row">
                        <div className="col-md-12">
                           <div className="grid grid-center margin-bottom-md text-left">
                              <div className="unit-2-3 unit-1-1-md blog-t">
                                 <h2 className="flourish text-left">
                                    <span className="flourish-square">
                                       <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 150 150"
                                          width="150"
                                          height="150"
                                          preserveAspectRatio="xMidYMid meet"
                                          style={{ width: '100%', height: '100%', transform: 'translate3d(0px, 0px, 0px)' }}
                                       >
                                          <defs>
                                             <clipPath id="__lottie_element_147">
                                                <rect width="150" height="150" x="0" y="0"></rect>
                                             </clipPath>
                                          </defs>
                                          <g clipPath="url(#__lottie_element_147)">
                                             <g style={{ display: 'block' }} transform="matrix(1,0,0,1,459,133.5)" opacity="1">
                                                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                                   <path
                                                      strokeLinecap="butt"
                                                      strokeLinejoin="miter"
                                                      fillOpacity="0"
                                                      strokeMiterlimit="4"
                                                      stroke="rgb(232,154,167)"
                                                      strokeOpacity="1"
                                                      strokeWidth="10"
                                                      d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"
                                                   ></path>
                                                </g>
                                             </g>
                                          </g>
                                       </svg>
                                    </span>
                                    {PageContent.content_title[1]?.title || 'On Demand Moving & Delivery Services'}
                                 </h2>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="row">
                        <div className="col-md-6 demandMoveLeft leftDemandSliderSingle">
                           <Slider {...slider_settings_3}>
                              {PageContent.content_title[1]?.page_content && PageContent.content_title[1].page_content.length > 0 &&
                                 PageContent.content_title[1].page_content.slice(0, 3).map((option_1, index_1) => (
                                    <div className="item item1" key={index_1}>
                                       <Link to={'/' + option_1.page_title_alias} className="item-image" tabIndex="0">
                                          <img
                                             src={option_1.content_photo}
                                             className="attachment-medium size-medium wp-post-image"
                                             alt={option_1.content_title}
                                             loading="lazy"
                                          />
                                       </Link>
                                       <div className="item-text">
                                          <Link to={'/' + option_1.page_title_alias} tabIndex="0">
                                             <h3 className="item-title">{option_1.content_title}</h3>
                                          </Link>
                                          <span className="item-meta">
                                             <span className="meta-date">{option_1.created_datetime || 'Unknown Date'}</span>
                                          </span>
                                       </div>
                                    </div>
                                 ))}
                           </Slider>
                        </div>

                        <div className="col-md-6">
                           <div className="scrollBoxBlog" id="style-4">
                              <div className="row gs-0">
                                 {PageContent.content_title[1]?.page_content && PageContent.content_title[1].page_content.length > 3 &&
                                    PageContent.content_title[1].page_content.slice(3).map((option_1, index_1) => (
                                       <div className="col-md-6 rightFourNews" key={index_1}>
                                          <div className="item item2">
                                             <Link to={'/' + option_1.page_title_alias} className="item-image" tabIndex="0">
                                                <img
                                                   src={option_1.content_photo}
                                                   className="attachment-medium size-medium wp-post-image"
                                                   alt={option_1.content_title}
                                                   loading="lazy"
                                                />
                                             </Link>
                                             <div className="item-text">
                                                <Link to={'/' + option_1.page_title_alias} tabIndex="0">
                                                   <h3 className="item-title">{option_1.content_title}</h3>
                                                </Link>
                                                <span className="item-meta">
                                                   <span className="meta-date">{option_1.created_datetime || 'Unknown Date'}</span>
                                                </span>
                                             </div>
                                          </div>
                                       </div>
                                    ))}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </section>
            )
         }
         {/* <section className="demandMove">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">
                     <div className="grid grid-center margin-bottom-md text-left">
                        <div className="unit-2-3 unit-1-1-md blog-t">
                           <h2 className="flourish text-left">
                              <span className="flourish-square">
                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="150" height="150" preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "100%", transform: "translate3d(0px, 0px, 0px)" }}><defs><clipPath id="__lottie_element_147"><rect width="150" height="150" x="0" y="0"></rect></clipPath></defs><g clipPath="url(#__lottie_element_147)"><g style={{ display: "block" }} transform="matrix(1,0,0,1,459,133.5)" opacity="1"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke="rgb(232,154,167)" strokeOpacity="1" strokeWidth="10" d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"></path></g></g></g></svg>
                              </span>On Demand Moving & Delivery Services</h2>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-md-6 demandMoveLeft leftDemandSliderSingle">
                     <Slider {...slider_settings_3}>
                        <div class="item item1">
                           <a href="" class="item-image">
                              <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1738238773.jpg" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                           </a>
                           <div class="item-text">
                              <a href="">
                                 <h3 class="item-title">Top 5 Reasons to Choose On-Demand Moving Services for Your Next Relocation</h3>
                              </a>
                              <div class="item-desc">
                                 Relocating can be overwhelming, but it doesn’t have to be. With movers on demand, you get speed, flexibility, and reliability tailored to your needs.
                              </div>
                              <span class="item-meta">
                                 <span class="meta-date"> 23 May, 2025</span>
                              </span>
                           </div>
                        </div>
                        <div class="item item1">
                           <a href="" class="item-image">
                              <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1721974279.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                           </a>
                           <div class="item-text">
                              <a href="">
                                 <h3 class="item-title">Your Guide to Preparing an Apartment Before You Move In</h3>
                              </a>
                              <div class="item-desc">
                                 Relocating can be overwhelming, but it doesn’t have to be. With movers on demand, you get speed, flexibility, and reliability tailored to your needs.
                              </div>
                              <span class="item-meta">
                                 <span class="meta-date"> 23 May, 2025</span>
                              </span>
                           </div>
                        </div>
                     </Slider>
                  </div>

                  <div className="col-md-6">
                     <div className="scrollBoxBlog" id="style-4">
                        <div className="row gs-0">
                           <div className="col-md-6 rightFourNews">
                              <div class="item item2">
                                 <a href="" class="item-image">
                                    <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1743748367.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                 </a>
                                 <div class="item-text">
                                    <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience</h3></a>
                                    <span class="item-meta">
                                       <span class="meta-date"> Mar 08, 2017</span>
                                    </span>
                                 </div>
                              </div>
                           </div>
                           <div className="col-md-6 rightFourNews">
                              <div class="item item2">
                                 <a href="" class="item-image">
                                    <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1739952034.webp" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                 </a>
                                 <div class="item-text">
                                    <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience</h3></a>
                                    <span class="item-meta">
                                       <span class="meta-date"> Mar 08, 2017</span>
                                    </span>
                                 </div>
                              </div>
                           </div>
                           <div className="col-md-6 rightFourNews">
                              <div class="item item2">
                                 <a href="" class="item-image">
                                    <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1736148152.jpg" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                 </a>
                                 <div class="item-text">
                                    <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience</h3></a>
                                    <span class="item-meta">
                                       <span class="meta-date"> Mar 08, 2017</span>
                                    </span>
                                 </div>
                              </div>
                           </div>
                           <div className="col-md-6 rightFourNews">
                              <div class="item item2">
                                 <a href="" class="item-image">
                                    <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1733305301.jpg" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                 </a>
                                 <div class="item-text">
                                    <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience</h3></a>
                                    <span class="item-meta">
                                       <span class="meta-date"> Mar 08, 2017</span>
                                    </span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section> */}

         {
            PageContent && PageContent.content_title && PageContent.content_title.length > 2 && (
               <section className="moveItAndNewApp">
                  <div className="container">
                     <div className="row">
                        <div className="col-md-12">
                           <div className="grid grid-center margin-bottom-md text-left">
                              <div className="unit-2-1 unit-1-1-md blog-t">
                                 <h2 className="flourish text-left">
                                    <span className="flourish-square">
                                       <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 150 150"
                                          width="150"
                                          height="150"
                                          preserveAspectRatio="xMidYMid meet"
                                          style={{ width: '100%', height: '100%', transform: 'translate3d(0px, 0px, 0px)' }}
                                       >
                                          <defs>
                                             <clipPath id="__lottie_element_147">
                                                <rect width="150" height="150" x="0" y="0"></rect>
                                             </clipPath>
                                          </defs>
                                          <g clipPath="url(#__lottie_element_147)">
                                             <g style={{ display: 'block' }} transform="matrix(1,0,0,1,459,133.5)" opacity="1">
                                                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                                   <path
                                                      strokeLinecap="butt"
                                                      strokeLinejoin="miter"
                                                      fillOpacity="0"
                                                      strokeMiterlimit="4"
                                                      stroke="rgb(232,154,167)"
                                                      strokeOpacity="1"
                                                      strokeWidth="10"
                                                      d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"
                                                   ></path>
                                                </g>
                                             </g>
                                          </g>
                                       </svg>
                                    </span>
                                    {PageContent.content_title[2]?.title}
                                 </h2>
                              </div>
                           </div>
                        </div>
                        <div className="col-md-8 col-lg-8 pr-md-5 allPostPl">
                           <div className="row">
                              {PageContent.content_title[2]?.page_content && PageContent.content_title[2].page_content.length > 0 &&
                                 PageContent.content_title[2].page_content.slice(0, 3).map((option_1, index_1) => (
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-12 pl-0" key={index_1}>
                                       <div className="mb-5 d-md-flex justify-content-between postbox">
                                          <div className="col-md-5 pl-0 text-md-right mb-3 mb-md-0">
                                             <Link to={'/' + option_1.page_title_alias} className="w-100" tabIndex="0">
                                                <img
                                                   src={option_1.content_photo}
                                                   alt={option_1.content_title}
                                                   className="attachment-medium size-medium wp-post-image"
                                                   loading="lazy"
                                                />
                                             </Link>
                                          </div>
                                          <div className="col-md-7 pl-0">
                                             <h2 className="mb-2">
                                                <Link to={'/' + option_1.page_title_alias} tabIndex="0">
                                                   {option_1.content_title}
                                                </Link>
                                             </h2>
                                             <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                   <div className="textPinkOr small">{option_1.created_datetime || 'Unknown Date'}</div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 ))}
                           </div>
                        </div>
                        <div className="col-md-4 col-lg-4 thesidebar">
                           <div className="scrollBoxBlog-1" id="style-4">
                              <div className="row">
                                 <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div className="rightRelated">
                                       <div className="related-articles">
                                          <ul className="item-list related-list">
                                             {PageContent.content_title[2]?.page_content && PageContent.content_title[2].page_content.length > 3 &&
                                                PageContent.content_title[2].page_content.slice(3).map((option_1, index_1) => (
                                                   <li className="item related-item" key={index_1}>
                                                      <Link to={'/' + option_1.page_title_alias} className="item-image" tabIndex="0">
                                                         <img
                                                            src={option_1.content_photo}
                                                            className="attachment-medium size-medium wp-post-image"
                                                            alt={option_1.content_title}
                                                            loading="lazy"
                                                         />
                                                      </Link>
                                                      <span className="item-text">
                                                         <Link to={'/' + option_1.page_title_alias} tabIndex="0">
                                                            <h4 className="item-title">{option_1.content_title}</h4>
                                                         </Link>
                                                         <span className="item-meta">
                                                            <span className="meta-author">
                                                               {option_1.description || 'No description available.'}
                                                            </span>
                                                            <span className="meta-date">{option_1.created_datetime || 'Unknown Date'}</span>
                                                         </span>
                                                      </span>
                                                   </li>
                                                ))}
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </section>
            )
         }
         {/* <section className="moveItAndNewApp">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">
                     <div className="grid grid-center margin-bottom-md text-left">
                        <div className="unit-2-1 unit-1-1-md blog-t">
                           <h2 className="flourish text-left">
                              <span className="flourish-square">
                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="150" height="150" preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "100%", transform: "translate3d(0px, 0px, 0px)" }}><defs><clipPath id="__lottie_element_147"><rect width="150" height="150" x="0" y="0"></rect></clipPath></defs><g clipPath="url(#__lottie_element_147)"><g style={{ display: "block" }} transform="matrix(1,0,0,1,459,133.5)" opacity="1"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke="rgb(232,154,167)" strokeOpacity="1" strokeWidth="10" d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"></path></g></g></g></svg>
                              </span>Revolutionary New App</h2>
                        </div>
                     </div>
                  </div>
                  <div className="col-md-8 col-lg-8 pr-md-5 allPostPl">
                     <div className="row">

                        <div class="col-xl-12 col-lg-12 col-md-12 col-12 pl-0">
                           <div class="mb-5 d-md-flex justify-content-between postbox">
                              <div class="col-md-5 pl-0 text-md-right mb-3 mb-md-0">
                                 <a href="" class="w-100">
                                    <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1744802234.png" alt="" />
                                 </a>
                              </div>
                              <div class="col-md-7 pl-0">
                                 <h2 class="mb-2">
                                    <a class="" href=""> Moving with Kids? Here’s How to Keep Them Happy and Stress-Free</a>
                                 </h2>
                                 <p class="excerpt description">Moving is a big change for everyone, but for children, it can be especially overwhelming. Whether you're relocating across town or to a new state, kids need extra reassurance and engagement to make the transition smoother.</p>
                                 <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                       <div class="textPinkOr small">May 22, 2025</div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div class="col-xl-12 col-lg-12 col-md-12 col-12 pl-0">
                           <div class="mb-5 d-md-flex justify-content-between postbox">
                              <div class="col-md-5 pl-0 text-md-right mb-3 mb-md-0">
                                 <a href="" class="w-100">
                                    <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1745920425.png" alt="" />
                                 </a>
                              </div>
                              <div class="col-md-7 pl-0">
                                 <h2 class="mb-2">
                                    <a class="" href=""> How to Make Moving Less Stressful for Seniors</a>
                                 </h2>
                                 <p class="excerpt description">Moving is a big change for everyone, but for children, it can be especially overwhelming. Whether you're relocating across town or to a new state, kids need extra reassurance and engagement to make the transition smoother.</p>
                                 <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                       <div class="textPinkOr small">May 22, 2025</div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div class="col-xl-12 col-lg-12 col-md-12 col-12 pl-0">
                           <div class="mb-5 d-md-flex justify-content-between postbox">
                              <div class="col-md-5 pl-0 text-md-right mb-3 mb-md-0">
                                 <a href="" class="w-100">
                                    <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1745317485.png" alt="" />
                                 </a>
                              </div>
                              <div class="col-md-7 pl-0">
                                 <h2 class="mb-2">
                                    <a class="" href=""> Moving with Kids? Here’s How to Keep Them Happy and Stress-Free</a>
                                 </h2>
                                 <p class="excerpt description">Moving is a big change for everyone, but for children, it can be especially overwhelming. Whether you're relocating across town or to a new state, kids need extra reassurance and engagement to make the transition smoother.</p>
                                 <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                       <div class="textPinkOr small">May 22, 2025</div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div >

                  </div >


                  <div className="col-md-4 col-lg-4 thesidebar">

                     <div className="scrollBoxBlog-1" id="style-4">
                        <div class="row">
                           <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                              <div className="rightRelated">
                                 <div className="related-articles">
                                    <ul class="item-list related-list">
                                       <li class="item related-item">
                                          <a href="" class="item-image">
                                             <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1745317485.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                          </a>
                                          <span class="item-text">
                                             <a href="">
                                                <h4 class="item-title">Traditional Self-Storage vs. Full-Service Storage: Which Option is Right for You?</h4>
                                             </a>
                                             <span class="item-meta">
                                                <span class="meta-author"> Moving is a big change for everyone, but for children, it can be especially</span>
                                                <span class="meta-date"> May 12, 2025</span>
                                             </span>
                                          </span>
                                       </li>
                                       <li class="item related-item">
                                          <a href="" class="item-image">
                                             <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1744802234.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                          </a>
                                          <span class="item-text">
                                             <a href="">
                                                <h4 class="item-title">Traditional Self-Storage vs. Full-Service Storage: Which Option is Right for You?</h4>
                                             </a>
                                             <span class="item-meta">
                                                <span class="meta-author"> Moving is a big change for everyone, but for children, it can be especially</span>
                                                <span class="meta-date"> May 12, 2025</span>
                                             </span>
                                          </span>
                                       </li>
                                       <li class="item related-item">
                                          <a href="" class="item-image">
                                             <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1745317485.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                          </a>
                                          <span class="item-text">
                                             <a href="">
                                                <h4 class="item-title">Traditional Self-Storage vs. Full-Service Storage: Which Option is Right for You?</h4>
                                             </a>
                                             <span class="item-meta">
                                                <span class="meta-author"> Moving is a big change for everyone, but for children, it can be especially</span>
                                                <span class="meta-date"> May 12, 2025</span>
                                             </span>
                                          </span>
                                       </li>
                                       <li class="item related-item">
                                          <a href="" class="item-image">
                                             <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1744802234.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                          </a>
                                          <span class="item-text">
                                             <a href="">
                                                <h4 class="item-title">Traditional Self-Storage vs. Full-Service Storage: Which Option is Right for You?</h4>
                                             </a>
                                             <span class="item-meta">
                                                <span class="meta-author"> Moving is a big change for everyone, but for children, it can be especially</span>
                                                <span class="meta-date"> May 12, 2025</span>
                                             </span>
                                          </span>
                                       </li>
                                       <li class="item related-item">
                                          <a href="" class="item-image">
                                             <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1745317485.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                          </a>
                                          <span class="item-text">
                                             <a href="">
                                                <h4 class="item-title">Traditional Self-Storage vs. Full-Service Storage: Which Option is Right for You?</h4>
                                             </a>
                                             <span class="item-meta">
                                                <span class="meta-author"> Moving is a big change for everyone, but for children, it can be especially</span>
                                                <span class="meta-date"> May 12, 2025</span>
                                             </span>
                                          </span>
                                       </li>
                                       <li class="item related-item">
                                          <a href="" class="item-image">
                                             <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1744802234.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                                          </a>
                                          <span class="item-text">
                                             <a href="">
                                                <h4 class="item-title">Traditional Self-Storage vs. Full-Service Storage: Which Option is Right for You?</h4>
                                             </a>
                                             <span class="item-meta">
                                                <span class="meta-author"> Moving is a big change for everyone, but for children, it can be especially</span>
                                                <span class="meta-date"> May 12, 2025</span>
                                             </span>
                                          </span>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                  </div>



               </div >
            </div >
         </section > */}

         {
            PageContent && PageContent.content_title && PageContent.content_title.length > 3 && (
               <section className="demandMove bg-white pt-3">
                  <div className="container">
                     <div className="row">
                        <div className="col-md-12">
                           <div className="grid grid-center margin-bottom-md text-left">
                              <div className="unit-2-3 unit-1-1-md blog-t">
                                 <h2 className="flourish text-left">
                                    <span className="flourish-square">
                                       <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 150 150"
                                          width="150"
                                          height="150"
                                          preserveAspectRatio="xMidYMid meet"
                                          style={{ width: '100%', height: '100%', transform: 'translate3d(0px, 0px, 0px)' }}
                                       >
                                          <defs>
                                             <clipPath id="__lottie_element_147">
                                                <rect width="150" height="150" x="0" y="0"></rect>
                                             </clipPath>
                                          </defs>
                                          <g clipPath="url(#__lottie_element_147)">
                                             <g style={{ display: 'block' }} transform="matrix(1,0,0,1,459,133.5)" opacity="1">
                                                <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                                   <path
                                                      strokeLinecap="butt"
                                                      strokeLinejoin="miter"
                                                      fillOpacity="0"
                                                      strokeMiterlimit="4"
                                                      stroke="rgb(232,154,167)"
                                                      strokeOpacity="1"
                                                      strokeWidth="10"
                                                      d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"
                                                   ></path>
                                                </g>
                                             </g>
                                          </g>
                                       </svg>
                                    </span>
                                    {PageContent.content_title[3]?.title || 'Move It'}
                                 </h2>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="row gs-0 moveItBlogLast">
                        <div className="container full-width">
                           <Slider {...slider_settings_4} className="carousel">
                              {PageContent.content_title[3]?.page_content && PageContent.content_title[3].page_content.length > 0 &&
                                 PageContent.content_title[3].page_content.map((option_1, index_1) => (
                                    <div className="rightFourNews" key={index_1}>
                                       <div className="item item2">
                                          <Link to={'/' + option_1.page_title_alias} className="item-image" tabIndex="0">
                                             <img
                                                src={option_1.content_photo}
                                                className="attachment-medium size-medium wp-post-image"
                                                alt={option_1.content_title}
                                                loading="lazy"
                                             />
                                          </Link>
                                          <div className="item-text">
                                             <Link to={'/' + option_1.page_title_alias} tabIndex="0">
                                                <h3 className="item-title">{option_1.content_title}</h3>
                                             </Link>
                                             <span className="item-meta">
                                                <span className="meta-date">{option_1.created_datetime || 'Unknown Date'}</span>
                                             </span>
                                          </div>
                                       </div>
                                    </div>
                                 ))}
                           </Slider>
                        </div>
                     </div>
                  </div>
               </section>
            )
         }

         {/* <section className="demandMove bg-white pt-3">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">
                     <div className="grid grid-center margin-bottom-md text-left">
                        <div className="unit-2-3 unit-1-1-md blog-t">
                           <h2 className="flourish text-left">
                              <span className="flourish-square">
                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="150" height="150" preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "100%", transform: "translate3d(0px, 0px, 0px)" }}><defs><clipPath id="__lottie_element_147"><rect width="150" height="150" x="0" y="0"></rect></clipPath></defs><g clipPath="url(#__lottie_element_147)"><g style={{ display: "block" }} transform="matrix(1,0,0,1,459,133.5)" opacity="1"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke="rgb(232,154,167)" strokeOpacity="1" strokeWidth="10" d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"></path></g></g></g></svg>
                              </span>Move It</h2>
                        </div>
                     </div>
                  </div>
               </div>


               <div className="row gs-0 moveItBlogLast">
                  <div className="container full-width">
                     <Slider {...slider_settings_4} className="carousel">
                        <div className="rightFourNews">
                           <div class="item item2">
                              <a href="" class="item-image">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1746439249.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </a>
                              <div class="item-text">
                                 <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience 1</h3></a>
                                 <span class="item-meta">
                                    <span class="meta-date"> Mar 08, 2017</span>
                                 </span>
                              </div>
                           </div>
                        </div>
                        <div className="rightFourNews">
                           <div class="item item2">
                              <a href="" class="item-image">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1746189701.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </a>
                              <div class="item-text">
                                 <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience 2</h3></a>
                                 <span class="item-meta">
                                    <span class="meta-date"> Mar 08, 2017</span>
                                 </span>
                              </div>
                           </div>
                        </div>
                        <div className="rightFourNews">
                           <div class="item item2">
                              <a href="" class="item-image">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1745834996.png" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </a>
                              <div class="item-text">
                                 <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience 3</h3></a>
                                 <span class="item-meta">
                                    <span class="meta-date"> Mar 08, 2017</span>
                                 </span>
                              </div>
                           </div>
                        </div>
                        <div className="rightFourNews">
                           <div class="item item2">
                              <a href="" class="item-image">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1739952034.webp" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </a>
                              <div class="item-text">
                                 <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience 4</h3></a>
                                 <span class="item-meta">
                                    <span class="meta-date"> Mar 08, 2017</span>
                                 </span>
                              </div>
                           </div>
                        </div>
                        <div className="rightFourNews">
                           <div class="item item2">
                              <a href="" class="item-image">
                                 <img src="https://moveit-ntqy34sm0nqzmp55qu06gp.s3.us-west-1.amazonaws.com/web_content_images/img_1736148152.jpg" class="attachment-medium size-medium wp-post-image" alt="" loading="lazy" />
                              </a>
                              <div class="item-text">
                                 <a href=""><h3 class="item-title">How White-Glove Moving Services Elevate Your Relocation Experience 5</h3></a>
                                 <span class="item-meta">
                                    <span class="meta-date"> Mar 08, 2017</span>
                                 </span>
                              </div>
                           </div>
                        </div>

                     </Slider>
                  </div>

               </div>



            </div>
         </section> */}





         {/* {PageContent && PageContent.content_title && PageContent.content_title.length > 0 && PageContent.content_title.map((option, index) => (
            <section key={index}>
               {option.page_content.length > 0 ?
                  <>
                     <article>
                        <div className="grid grid-center margin-bottom-lg text-left">
                           <div className="unit-2-3 unit-1-1-md blog-t">
                              <h2 className="flourish text-left"><span className="flourish-square"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="150" height="150" preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "100%", transform: "translate3d(0px, 0px, 0px)" }}><defs><clipPath id="__lottie_element_147"><rect width="150" height="150" x="0" y="0"></rect></clipPath></defs><g clipPath="url(#__lottie_element_147)"><g style={{ display: "block" }} transform="matrix(1,0,0,1,459,133.5)" opacity="1"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke="rgb(232,154,167)" strokeOpacity="1" strokeWidth="10" d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"></path></g></g></g></svg></span>{option.title}</h2>
                           </div>
                        </div>

                        <div className="row">
                           <div className="col-lg-12">
                              <div className="row align-items-center d-flex align-center justify-content-center">

                                 {option.page_content && option.page_content.length > 0 && option.page_content.map((option_1, index_1) => (

                                    <div className={option.page_content.length == 1 || (option.page_content.length == 4 && index_1 == 3) ? "col-md-12 col-lg-9" : option.page_content.length == 2 ? "col-md-6 col-lg-5" : "col-md-6 col-lg-4"} key={index_1}>
                                       <div className="blogbox">
                                          <Link to={'/' + option_1.page_title_alias}>
                                             <div className="ovlay"></div>
                                             <img src={option_1.content_photo} alt="" />
                                             <div className="contentbox-blog">
                                                <h3>{option_1.content_title} </h3>
                                                <div className="profileimg">
                                                   <span><small>{option_1?.created_datetime ? option_1.created_datetime : ''}</small></span>
                                                </div>
                                             
                                             </div>
                                          </Link>
                                       </div>
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </div>


                     </article>
                  </>
                  : ''}
            </section>
         ))}
*/}


         <Footer></Footer>
      </>
   );
}

export default Pages;
